/**
 * Part of starter project.
 *
 * @copyright  Copyright (C) 2021 __ORGANIZATION__.
 * @license    __LICENSE__
 */

// header bg
switchHeaderBg();

const headerCollapse = document.getElementById('navbarSupportedContent');

headerCollapse.addEventListener('show.bs.collapse', function () {
  const header = document.querySelector('#header');
  const navLinkItems = header.getElementsByClassName('c-nav-item');

  if (!header.classList.contains('bg-white')) {
    header.classList.add('bg-white');

    for (let i = 0; i < navLinkItems.length; i++) {
      navLinkItems[i].classList.remove('text-white');
      navLinkItems[i].classList.add('text-base');
    }
  }
})

headerCollapse.addEventListener('hidden.bs.collapse', function () {
  switchHeaderBg();
});

window.addEventListener('scroll', () => {
  switchHeaderBg();
});

function switchHeaderBg() {
  const header = document.querySelector('#header');
  const navLinkItems = header.getElementsByClassName('c-nav-item');
  const currentHeight = window.scrollY;

  if (currentHeight >= 1) {
    if (!header.classList.contains('bg-white')) {
      header.classList.add('bg-white');
    }

    for (let i = 0; i < navLinkItems.length; i++) {
      navLinkItems[i].classList.remove('text-white');
      navLinkItems[i].classList.add('text-base');
    }
  }

  if (currentHeight < 1) {
    if (header.classList.contains('bg-white')) {
      header.classList.remove('bg-white');
    }

    for (let i = 0; i < navLinkItems.length; i++) {
      navLinkItems[i].classList.remove('text-base');
      navLinkItems[i].classList.add('text-white');
    }
  }
};

const swiper = new Swiper('#banner-swiper', {
  autoplay:true,
  speed: 400,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    renderBullet: function (index, className) {
      let number = ('000000' + (index + 1)).substr(-2);

      return '<span class="' + className + '">' + number + '</span>';
    },
  },
});
